import {
  CombinationKey,
  getCombinationLabel as getLabel,
} from '@lbs/shared-rp-types'
import { useTranslation } from 'react-i18next'

export const useHandCombinationTranslation = () => {
  const { i18n } = useTranslation()

  const getCombinationLabel = (combination: CombinationKey): string => {
    const currentLanguage = i18n.language as 'en' | 'ru' | undefined

    return (
      getLabel(combination, currentLanguage) ||
      getLabel(combination, 'en') ||
      combination
    )
  }

  return { getCombinationLabel }
}
